// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__3Rh1L","message":"CookieConsent_message__3xzBv","cookieLink":"CookieConsent_cookieLink__ZZlp6","continueBtn":"CookieConsent_continueBtn__2Zno2"};